import axios from "axios";
import CookiesHelper from "./cookiesHelper";

export const apiCall = (url, method="get", data={}) => { 
 

    return axios({
        method: method,
        url: url,
        data: data,
        headers: { 
            token:CookiesHelper.getAccessToken()
        }
    }).then(({ response }) => {
        return response;
    }).catch((error) => {
        throw new Error(error);
    });
};